import React, { useState, useEffect } from "react";
import { Field, Form, Formik, FormikHelpers as FormikActions, FormikProps } from "formik";
import SelectAsyncPaginate from './GeneSelectForVariant';
import PhenotypeSelect from './PhenotypeSelectForVariant';
import { useRouter } from 'next/router';
import Router from 'next/router';
import axios from 'axios';
import { Button, Stack, Box, Heading, HStack, VStack, Text, Divider, useColorModeValue } from "@chakra-ui/react"
import CheckboxGroup from "./CheckboxGroup";

const MultiSelectForm = (instanceId) => {
  const [conditionOptions, setConditionOptions] = useState([])
  const [myQuery, setMyQuery] = useState([])
  
  const router = useRouter()
  const borderColor = useColorModeValue("gray.200", "neutral.900")
  const buttonColor = useColorModeValue('gray.600', 'gray.600');
  const buttonBG = useColorModeValue('cyan.300', 'cyan.300');

  // console.log(router);
  const path = router.pathname.replace('[slug]', router.query.slug)

  // const fetchQueryData = async() => {
  //   var results = []
  //   const queryString = typeof router.query.gene == 'object' ? router.query.gene.map(gene => "&gene=" + gene).join('') : `gene=${router.query.gene}`
  //   const response = await axios.get(`http://127.0.0.1:8000/api/genes_filter?${queryString}`)
  //     if (response.statusText == "OK") {
  //       response.data.results.map(result => results.push({
  //         value: result.value,
  //         label: result.label
  //         }))
  //         setConditionOptions(results)
  //       return results
  //     }
  //   }


  // useEffect(()=>{
  //   if(router.query.gene) {
  //   fetchQueryData()
  // }

  // }, [router])

  const onSubmit = (values, actions) => {
    // alert(JSON.stringify(values, null, 2));
    router.push({
      pathname: path,
      query: {...values, page: 1 },
  });
  actions.setSubmitting(false);
  };

  const onReset = (values, actions) => {
    // alert(JSON.stringify(values, null, 2));
    setConditionOptions([])
    router.push({
      pathname: path,
      query: {...values, page: 1 },
  });
  actions.setSubmitting(false);
  }

  const renderForm = (formikBag) => (
    
    <Form>
      {/* <Text as='label' fontSize={14} size="s" mb="2" fontWeight="normal">Gene</Text>
      <Field
        className="gene-select"
        name="gene"
        options={conditionOptions}
        component={SelectAsyncPaginate}
        placeholder="Search or select genes"
        isMulti={true}
        isClearable={true}
        isSearchable={true}
        query={myQuery}
        instanceId={instanceId}
      /> */}
      {/* <Divider orientation="horizontal" mt={5} borderColor={borderColor}/> */}
      {/* <Box mt={10}><Text as='label' fontSize={14} size="s" mb="2" fontWeight="normal">Phenotype</Text></Box>
      <Field
        className="phenotype-select"
        name="phenotype"
        options={conditionOptions}
        component={PhenotypeSelect}
        placeholder="Search or select phenotypes"
        isMulti={true}
        isClearable={true}
        isSearchable={true}
        query={myQuery}
        instanceId={instanceId}
      /> */}
      <Box mt={8}>
        <Text as='label' fontSize={14} size="s" mb="2" fontWeight="normal">Significance</Text>
        <Box border="1px" p={4} borderRadius={8} borderColor={borderColor}>
          <CheckboxGroup
              name="significance"
          >
            <CheckboxGroup.Item label="Pathogenic" value="pathogenic" />
            <CheckboxGroup.Item label="Benign" value="benign" />
          </CheckboxGroup>
          </Box>
        </Box>
      <Stack spacing={2} direction="row" align="center" mt={8}>
      <Button 
        colorScheme="gray" 
        type="submit" 
        borderRadius="12"
        onClick={formikBag.handleReset}
        disabled={!formikBag.dirty || formikBag.isSubmitting}
        size="sm"
      >
        Reset
      </Button>
      <Button type="submit" size="sm" color={buttonColor} bg={buttonBG} borderRadius={12} _hover={{bg: "gray.600", color: "gray.50"}}>
        Apply Filters
      </Button>
      </Stack>
    </Form>
  );

  return (
    <Formik
      initialValues={{ gene: [], clinvarphenotype: [], significance: []}}
      onSubmit={onSubmit}
      onReset={onReset}
      enableReinitialize={true}
    >
      {props => (
        renderForm(props)
      )}
    </Formik>
  );
};

const GeneFilters = (instanceId) => {
  return (
      <>
      <Box>
      <MultiSelectForm instanceId={instanceId}/>
      </Box>
      </>
  );
};

export default GeneFilters;

